import { urlLabel } from '@/enum/PermissionEnum';
import AcknowledgeScreen from '@/module/acknowledge-result';
import {
  ForgotPassword,
  InternalLogin,
  Login,
  ResetPassword,
  PatientLogin,
} from '@/module/auth';
import PatientForgotPassword from '@/module/auth/component/PatientForgotPassword';
import VerifySingpassScreen from '@/module/verify-singpass';
import React from 'react';
import { Redirect } from 'react-router-dom';

const authRoutes = [
  {
    path: `/${urlLabel.login}`,
    component: Login,
    exact: true,
  },
  {
    path: `/${urlLabel.internalLogin}`,
    component: InternalLogin,
    exact: true,
  },
  {
    // Internal sign-up is closed; accounts are created by an admin. Redirected
    // rather than deleted so an old bookmark lands on the login screen instead
    // of a blank page - same treatment as `register` below.
    path: `/${urlLabel.internalRegister}`,
    component: () => <Redirect to={`/${urlLabel.internalLogin}`} />,
    exact: true,
  },
  {
    path: `/${urlLabel.register}`,
    component: () => <Redirect to={`/${urlLabel.login}`} />,
    exact: true,
  },
  {
    path: `/${urlLabel.forgotPassword}`,
    component: ForgotPassword,
    exact: true,
  },
  {
    path: `/${urlLabel.resetPassword}`,
    component: ResetPassword,
    exact: true,
    publicComponent: true,
  },
  {
    path: `/${urlLabel.resetPasswordOldUser}`,
    component: ResetPassword,
    exact: true,
    publicComponent: true,
  },
  {
    path: `/${urlLabel.acknowledgeResult}`,
    component: AcknowledgeScreen,
    exact: true,
    publicComponent: true,
  },
  {
    path: `/${urlLabel.verifySingpassSuccess}`,
    component: VerifySingpassScreen,
    exact: true,
    publicComponent: true,
  },

  // Auth Patient
  {
    path: `/${urlLabel.patientLogin}`,
    component: PatientLogin,
    exact: true,
  },
  {
    // Patient self sign-up is closed; accounts are created by staff. Redirected
    // rather than deleted so an old bookmark lands on the login screen instead
    // of a blank page.
    path: `/${urlLabel.patientRegister}`,
    component: () => <Redirect to={`/${urlLabel.patientLogin}`} />,
    exact: true,
  },
  {
    path: `/${urlLabel.patientForgotPassword}`,
    component: PatientForgotPassword,
    exact: true,
  },
];

export default authRoutes;
